module.exports = __webpack_public_path__ + "static/media/Gilroy-UltraLight.262df160.eot";